export const FEATURE_SELECTION = [
  "Indikator",
  "Capaian IK",
  "Capaian SS",
  "Dashboard",
  "Uang Muka",
  "Uang Muka Kegiatan",
  "Uang Muka Operasional",
  "Anggaran",
  "Akun Baru",
  "Realokasi",
  "Transaksi",
  "Dokumen",
  "Panduan",
  // "Timeline Anggaran",
  // "Laporan",
  // "FAQ",
  // "Aduan",
  // "Kalender",
  "History",
  "Pengaturan",
  "Pengaturan Unit Kerja",
  "Pengaturan User Role",
  "Pengaturan Daftar Akun",
  "Pengaturan Sumber Dana",
  "Pengaturan Kegiatan",
  "Pengaturan Jenis Kegiatan",
  "Pengaturan Kategori Kegiatan",
];

// Create, Read, Update, Delete
// Update Status : Update function for feature's status
// Operasi : show columns "Operasi" of feature
/* Other :
 * Transaksi : Cetak Laporan
 */
export const FEATURE_FUNCTION_SELECTION = {
  CapaianIK: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    UpdateStatus: true,
    CetakLaporan: true,
  },
  CapaianSS: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    UpdateStatus: true,
    CetakLaporan: true,
  },
  UMK: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    UpdateStatus: true,
    CetakLaporan: true,
  },
  UMO: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    CetakLaporan: true,
  },
  Realokasi: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    UpdateStatus: true,
    Delete: true,
  },
  Transaksi: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    UpdateStatus: true,
    CetakLaporan: true,
  },
  AkunBaru: {
    Create: true,
    Read: true,
    Operasi: true,
    Update: true,
    Delete: true,
    UpdateStatus: true,
  },
  TandaTerima: {
    Read: true
  }
};
